import { c as _c } from "react/compiler-runtime";
import { displayPercentageDiscount } from "@website/accommodation-ui/helpers/calculatePercentageDiscount";
import { useHotelReserveCardFooter } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-footer/hotel-reserve-card-footer.hooks";
import { HotelReservedCardFooterTypesPropertiesType } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-footer/hotel-reserved-card-footer.types";
import { HotelSnappPayBadge } from "@website/accommodation-ui/hotel-snapp-pay";
import { Button } from "@website/ui/button";
import { CounterButton } from "@website/ui/counter-button";
import { MiniChips } from "@website/ui/mini-chips";
import { Skeleton } from "@website/ui/skeleton";
import { isChannel } from "@website/utils/channel/helpers";
import { numberConvert } from "@website/utils/number-convert";
import { numberSeparator } from "@website/utils/number-separator";
import { SnappProDiscountChip } from "@website/website-ui/snapp-pro-discount-chip";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
export const HotelReserveCardFooter = properties => {
  const $ = _c(62);
  const {
    availableRooms,
    price,
    priceOff,
    pricedRoomCount,
    id,
    nightCount,
    minStay: t0,
    rackIncluded,
    onRacksClick,
    view: t1,
    snappPayData,
    roomDetail,
    onRoomCountLoading,
    hasSnappProDiscount,
    isRoomCountPriceAvailable
  } = properties;
  const minStay = t0 === undefined ? 1 : t0;
  const view = t1 === undefined ? "default" : t1;
  const router = useRouter();
  const {
    roomCount,
    setRoomCount,
    roomSelect,
    onHandleClick,
    loading,
    openDatePicker,
    handleRecommendedHotel
  } = useHotelReserveCardFooter(properties);
  const isPriceSyncedWithRoomCount = pricedRoomCount === roomCount;
  const priceMultiplier = isPriceSyncedWithRoomCount ? 1 : roomCount;
  const [isRoomCountPricePending, setIsRoomCountPricePending] = useState(false);
  const showRoomCountPriceLoading = onRoomCountLoading || isRoomCountPricePending;
  const displayPrice = price * priceMultiplier;
  const displayPriceOff = priceOff * priceMultiplier;
  const displayPayablePrice = (priceOff || price) * priceMultiplier;
  let t2;
  if ($[0] !== isRoomCountPriceAvailable || $[1] !== setRoomCount) {
    t2 = nextRoomCount => {
      if (isRoomCountPriceAvailable && !isRoomCountPriceAvailable(nextRoomCount)) {
        setIsRoomCountPricePending(true);
      }
      setRoomCount(nextRoomCount);
    };
    $[0] = isRoomCountPriceAvailable;
    $[1] = setRoomCount;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleRoomCountChange = t2;
  let t3;
  let t4;
  if ($[3] !== isPriceSyncedWithRoomCount) {
    t3 = () => {
      if (isPriceSyncedWithRoomCount) {
        setIsRoomCountPricePending(false);
      }
    };
    t4 = [isPriceSyncedWithRoomCount];
    $[3] = isPriceSyncedWithRoomCount;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  const t5 = `flex items-center justify-between pb-4 ${view === "mobile" ? "flex-col pt-3" : "flex-col pt-3 lg:min-h-[68px] lg:flex-row lg:px-4 lg:pt-4"}`;
  const t6 = `${view === "mobile" ? "hidden" : "text-caption hidden lg:order-1 lg:me-4 lg:block"}`;
  let t7;
  if ($[6] !== t6) {
    t7 = <div className={t6}>تعداد اتاق</div>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = `text-caption mr-4 ltr:ml-4 ${view === "mobile" ? "" : "lg:order-4 lg:m-0"}`;
  let t9;
  if ($[8] !== nightCount || $[9] !== router.locale) {
    t9 = numberConvert(nightCount, {
      locale: router.locale
    });
    $[8] = nightCount;
    $[9] = router.locale;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = `قیمت برای ${t9} شب`;
  let t11;
  if ($[11] !== t10 || $[12] !== t8) {
    t11 = <div className={t8}>{t10}</div>;
    $[11] = t10;
    $[12] = t8;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  const t12 = `text-subtitle-1 ml-4 flex min-h-[44px] min-w-[132px] flex-col items-end justify-center text-end ltr:mr-4 ${view === "mobile" ? "" : "lg:order-5 lg:mr-4 lg:ltr:ml-0"}`;
  let t13;
  if ($[14] !== displayPrice || $[15] !== displayPriceOff || $[16] !== hasSnappProDiscount || $[17] !== price || $[18] !== priceOff || $[19] !== router.locale || $[20] !== showRoomCountPriceLoading) {
    t13 = showRoomCountPriceLoading ? <div className="flex w-[132px] flex-col gap-2 self-end"><Skeleton height={20} /></div> : <>{price > priceOff && <div className="flex flex-row items-center justify-end gap-2"><span className="text-body-2 text-on-surface-medium-emphasis line-through">{numberConvert(numberSeparator(displayPrice), {
            locale: router.locale
          })}</span>{hasSnappProDiscount ? <SnappProDiscountChip percentage={displayPercentageDiscount(price, priceOff)} /> : <MiniChips color="primary" text={displayPercentageDiscount(price, priceOff)} variant="contained" />}</div>}<div>{numberConvert(numberSeparator(price - priceOff ? displayPriceOff : displayPrice), {
          locale: router.locale
        })}<span className="text-subtitle-2 px-1">تومان</span></div></>;
    $[14] = displayPrice;
    $[15] = displayPriceOff;
    $[16] = hasSnappProDiscount;
    $[17] = price;
    $[18] = priceOff;
    $[19] = router.locale;
    $[20] = showRoomCountPriceLoading;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t12 || $[23] !== t13) {
    t14 = <div className={t12}>{t13}</div>;
    $[22] = t12;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  const t15 = `bg-outline-thin mb-4 mt-3 block h-px w-full ${view === "mobile" ? "" : "lg:hidden"} ${snappPayData?.isEligible && snappPayData?.showDownPayment ? "hidden" : ""}`;
  let t16;
  if ($[25] !== t15) {
    t16 = <div className={t15} />;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== displayPayablePrice || $[28] !== snappPayData) {
    t17 = snappPayData?.isEligible && snappPayData?.showDownPayment && <div className="flex-auto basis-full py-4 lg:order-3 lg:basis-0 lg:px-4 lg:py-0">{!isChannel(["ads"]) && <HotelSnappPayBadge {...snappPayData} page="hotelPage" price={displayPayablePrice} />}</div>;
    $[27] = displayPayablePrice;
    $[28] = snappPayData;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  const t18 = `ms-4 !h-[36px] gap-0 ${view === "mobile" ? "" : "lg:order-2 lg:m-0"} ${view === "mobile" || snappPayData?.isEligible && snappPayData?.showDownPayment ? "" : "lg:flex-auto"}`;
  const t19 = roomCount <= 1 || showRoomCountPriceLoading;
  const t20 = roomCount >= availableRooms || showRoomCountPriceLoading;
  let t21;
  if ($[30] !== handleRoomCountChange || $[31] !== roomCount || $[32] !== t18 || $[33] !== t19 || $[34] !== t20) {
    t21 = <CounterButton className={t18} color="secondary" decreaseDisabled={t19} increaseDisabled={t20} locale="fa" onChange={handleRoomCountChange} size="small" value={roomCount} variant="outline" />;
    $[30] = handleRoomCountChange;
    $[31] = roomCount;
    $[32] = t18;
    $[33] = t19;
    $[34] = t20;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== handleRecommendedHotel || $[37] !== id || $[38] !== loading || $[39] !== minStay || $[40] !== nightCount || $[41] !== onHandleClick || $[42] !== onRacksClick || $[43] !== openDatePicker || $[44] !== rackIncluded || $[45] !== roomCount || $[46] !== roomDetail?.showRoomDetail || $[47] !== roomSelect || $[48] !== router.locale || $[49] !== view) {
    t22 = Number(nightCount) >= Number(minStay) ? rackIncluded && !roomDetail?.showRoomDetail ? <Button className={view === "mobile" ? "ml-4 w-[133px] ltr:mr-4" : "ml-4 w-[133px] lg:order-6 lg:col-span-2 lg:m-0 lg:w-[94px] ltr:mr-4"} onClick={onRacksClick} size="small">{`رزرو ${numberConvert(roomCount, {
        locale: router.locale
      })} اتاق`}</Button> : <Button className={view === "mobile" ? "ml-4 w-[133px] ltr:mr-4" : "ml-4 w-[133px] lg:order-6 lg:col-span-2 lg:m-0 lg:w-[94px] ltr:mr-4"} loading={id === roomSelect ? loading : false} onClick={onHandleClick} size="small">{`رزرو ${numberConvert(roomCount, {
        locale: router.locale
      })} اتاق`}</Button> : <div className={`order-6 mt-2 flex w-full flex-col px-4 ${view === "mobile" ? "" : "lg:flex-row lg:items-center lg:px-0"}`}><div className={`text-body-2 text-primary mb-2 flex-auto ${view === "mobile" ? "" : "lg:m-0"}`}>{minStay === 20 ? "\u0627\u06CC\u0646 \u0627\u062A\u0627\u0642 \u062F\u0631 \u062A\u0627\u0631\u06CC\u062E \u0648\u0631\u0648\u062F \u0627\u0646\u062A\u062E\u0627\u0628\u06CC \u0634\u0645\u0627 \u067E\u0630\u06CC\u0631\u0634 \u0646\u062F\u0627\u0631\u062F \u0644\u0637\u0641\u0627 \u062A\u0627\u0631\u06CC\u062E \u0627\u0642\u0627\u0645\u062A \u062E\u0648\u062F \u0631\u0627 \u062A\u063A\u06CC\u06CC\u0631 \u062F\u0647\u06CC\u062F" : `حداقل ${numberConvert(minStay, {
          locale: router.locale
        })} شب اقامت`}</div><div className="flex flex-row gap-2"><Button className={view === "mobile" ? "w-full" : "w-full lg:w-[94px]"} onClick={openDatePicker} size="small">تغییر تاریخ</Button><Button className={view === "mobile" ? "w-full" : "w-full lg:w-[122px]"} onClick={handleRecommendedHotel} size="small">هتل های مشابه</Button></div></div>;
    $[36] = handleRecommendedHotel;
    $[37] = id;
    $[38] = loading;
    $[39] = minStay;
    $[40] = nightCount;
    $[41] = onHandleClick;
    $[42] = onRacksClick;
    $[43] = openDatePicker;
    $[44] = rackIncluded;
    $[45] = roomCount;
    $[46] = roomDetail?.showRoomDetail;
    $[47] = roomSelect;
    $[48] = router.locale;
    $[49] = view;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== t11 || $[52] !== t14 || $[53] !== t16 || $[54] !== t17 || $[55] !== t21 || $[56] !== t22 || $[57] !== t7) {
    t23 = <div className="flex w-full flex-row flex-wrap items-center justify-between">{t7}{t11}{t14}{t16}{t17}{t21}{t22}</div>;
    $[51] = t11;
    $[52] = t14;
    $[53] = t16;
    $[54] = t17;
    $[55] = t21;
    $[56] = t22;
    $[57] = t7;
    $[58] = t23;
  } else {
    t23 = $[58];
  }
  let t24;
  if ($[59] !== t23 || $[60] !== t5) {
    t24 = <div className={t5}>{t23}</div>;
    $[59] = t23;
    $[60] = t5;
    $[61] = t24;
  } else {
    t24 = $[61];
  }
  return t24;
};